

























import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

@Component
export default class ClientGroupCreate extends ViewBase {
  @Prop({ type: Boolean, default: true }) visible!: boolean
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: String, default: '' }) tip1!: string
  @Prop({ type: String, default: '' }) name!: string
  @Prop({ type: String, default: '' }) btnyes!: string
  @Prop({ type: String, default: '' }) btnno!: string
  svisible = false
  sname: any = ''
  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
  }
  @Watch('name')
  watchName(name: any) {
    if (name) {
      this.sname = name
    } else {
      this.sname = ''
    }
  }
  onOk() {
    if (!this.sname) {
      this.$message.error(this.tip1)
    } else {
      this.$emit('onOk', this.sname)
      this.sname = ''
    }
  }
  onCancel() {
    this.svisible = false
    this.sname = ''
    this.$emit('onCancel')
  }
}
